// @flow

import React, { type Node } from 'react';

import { IfFeature, type Feature } from '@tectonics/prs/feature';

import { EftPaymentTypeCode } from './payment-type-code';

type Props = {
  allFeatures: ImmutableArray<Feature>,
};

export function EftForm({ allFeatures }: Props): Node {
  return (
    <>
      <IfFeature allFeatures={allFeatures} wanted="field_colombian_bank_list">
        <EftPaymentTypeCode />
      </IfFeature>
    </>
  );
}
